import { defineColumns } from '@juvare/platform-shared/features/storage';
export const organizationEntityName = 'organization';
export const orgIdPrefixForAlertService = 'org_';
export const orgTreePublicDataKey = 'organizationTree';
export const organizationColumns = defineColumns({
    name: {
        type: 'string-required',
        index: 'partial',
    },
    visible: {
        type: 'boolean-required',
        index: true,
    },
    address: {
        type: 'string',
    },
    search: {
        type: 'full-text-search',
        language: 'english',
        index: true,
    },
    pendingMembersNotificationOnEveryNotification: {
        type: 'boolean-required',
    },
    pendingMembersNotificationScheduleNextTime: {
        // Unix timestamp when to run next time, It should be updated after notifications checked
        type: 'number',
        index: true,
    },
    parentIds: {
        type: 'id-array',
    },
    // Constructed using the names of its parent organizations separated by slashes, this parameter is used to
    // ensure the uniqueness of an organization on the same level and under the same parent organizations.
    // Example path: Juvare/Software Engineering
    // Two organisations on the highest level with name Juvare cannot exist. However, having organizations
    // with the same name but under different parents is possible because having different parents will result in different paths
    // i.e Juvare/Software Engineering and Microsoft/Software Engineering
    path: {
        type: 'string',
        index: 'unique',
    },
    reportingId: {
        type: 'string',
    },
    // Organization type comes from Organization type classifier
    type: {
        type: 'string',
    },
    hasLogo: {
        type: 'boolean',
    },
    // define how many organizations user can join under organization tree with this prop.
    // It can be applied only for root level organization.
    maxNumberOfMembershipsPerOrgTree: {
        type: 'number',
    },
});
export class OrganizationTypeNotFoundError extends Error {
    constructor() {
        super(...arguments);
        this.type = 'unknown-organization-type';
        this.statusCode = 400;
        this.message = 'Organization type in classifier not found';
    }
}
export const orgColumnForAuditIdReplacement = 'name';
